import { TreatmentPlanItem } from "@/modules/admin/treatment/services/useTreatmentQuery"

interface TreatmentTableCountriesProps {
  row: TreatmentPlanItem
}

const TreatmentTableCountries = (props: TreatmentTableCountriesProps) => {
  const countriesString = props.row.countries.join(", ")
  return (
    <div className="truncate" title={countriesString}>
      {countriesString}
    </div>
  )
}

export { TreatmentTableCountries }
